import {
    USER_ADD,
    USER_EDIT,
    USER_REMOVE,
    UserAction,
    UserState,
    UsersState,
} from "./types";
import UserAPI from "../../api/user";

// ------ STATE ------ //

const initialState: UsersState = {
    current: {
        account: "",
        username: "",
        id: "",
        type: "",
        isElevatedUser: false
    },
    registeredUsers: {}
}

// ----- REDUCER ----- //

export default function userReducer(state = initialState, action: UserAction) : UsersState
{
    switch(action.type)
    {
        case USER_ADD:
            return addUser(state, action.account, action.username, action.id, action.userType, action.isElevatedUser);
        case USER_EDIT:
            return editUser(state, action.account, action.username, action.id, action.userType, action.isElevatedUser);
        case USER_REMOVE:
            return removeUser(state, action.account);
        default:
            return state;
    }
}

// ----- ACTIONS ----- //

function addUser(state: UsersState, account: string, username: string, id: string, type: string, isElevatedUser: boolean) : UsersState
{
    return {
        ...state,
        registeredUsers: {
            ...state.registeredUsers,
            [account]: {
                account,
                username,
                id,
                type,
                isElevatedUser
            }
        }
    };
}

function editUser(state: UsersState, account: string, username: string, id: string, type: string, isElevatedUser: boolean) : UsersState
{
    return {
        ...state,
        registeredUsers: {
            ...state.registeredUsers,
            [account]: {
                account,
                username,
                id,
                type,
                isElevatedUser
            }
        }
    };
}

function removeUser(state: UsersState, account: string) : UsersState
{
    return {
        ...state,
        registeredUsers: {
            ...Object.values(state.registeredUsers).filter(user=>{
                return user.account.toString() !== account.toString();
            }).reduce((map: any, user: UserState) => {
                map[user.account] = user;
                return map;
            }, {})
        }
    };
}

export function loadUsers(usersState: UsersState)
{
    return UserAPI.getUserData().then((userData: UserState) => {
        return UserAPI.getUserList().then((users: UserState[]) => {
            return {
                ...usersState,
                current: userData,
                registeredUsers: {
                    ...users.reduce((map: any, user)=>{
                        map[user.account] = user;
                        return map;
                    }, {}),
                }
            }
        });
    }).catch((err: Error)=>{
        return {
            ...usersState
        }
    });
}

// -------------------- //